/** True when the app is served from a local dev host (localhost / 127.0.0.1). */
export function isLocalDevHost(): boolean {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return (
    host === 'localhost' ||
    host === '127.0.0.1' ||
    host === '[::1]' ||
    host.startsWith('172.26') ||
    host.startsWith('192.168') ||
    host.startsWith('d3vc2n3kzx93lk.cloudfront.net') ||
    host.startsWith('crash-stag')
  );
}
